module.exports = __webpack_public_path__ + "static/media/amex-card.fd4c5bbe.png";